<div mat-dialog-title class="bio-header">
  <span class="dialog-title">{{ 'DIALOGS.NEW_BREAK_IN_OUT_TITLE' | translate }}</span>
  <button mat-icon-button type="button" (click)="onCancel()" aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-actions class="bio-footer">
  <button mat-button class="discard-changes" type="button" (click)="onCancel()">
    {{ 'COMMON.BUTTONS.CANCEL' | translate }}
  </button>
  <button mat-raised-button class="submit" type="button" (click)="onSave()">
    {{ 'COMMON.BUTTONS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
<mat-dialog-content class="bio-content">
  <form class="report-form" [formGroup]="breakInOutForm">
    <section class="bio-summary">
      <div class="bio-summary-item">
        <span class="bio-summary-label">{{ 'DIALOGS.MEJ_PROJECT' | translate }}</span>
        <span class="bio-summary-value">{{ breakInOutForm.get('project')?.value || '—' }}</span>
      </div>
      <div class="bio-summary-item">
        <span class="bio-summary-label">{{ 'REPORT_FORM.BREAK-INS/OUTS.AMOUNT_TO_BE_ADDED' | translate }}</span>
        <span class="bio-summary-value">{{ breakInOutForm.get('amountToBeAdded')?.value | number: '1.0-2' }}</span>
      </div>
      <div class="bio-summary-item">
        <span class="bio-summary-label">{{ 'REPORT_FORM.BREAK-INS/OUTS.BIO_AMOUNT' | translate }}</span>
        <span class="bio-summary-value">{{ breakInOutForm.get('amount')?.value | number: '1.0-2' }}</span>
      </div>
    </section>

    <div class="horizontal-form-field">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>{{ 'COLUMNS.BREAK_IN_OUT.JUSTIFICATION' | translate }}</mat-label>
        <textarea
          matInput
          formControlName="justification"
          rows="9"
          [attr.maxlength]="maxJustificationLength"
          required
        ></textarea>
        <mat-error
          *ngIf="
            breakInOutForm.get('justification')?.hasError('required') &&
            breakInOutForm.get('justification')?.touched
          "
        >
          {{ 'COMMON.LABELS.REQUIRED_FIELD' | translate }}
        </mat-error>
      </mat-form-field>
      <div class="char-count" [class.char-count--over]="(breakInOutForm.get('justification')?.value?.length || 0) > maxJustificationLength">
        {{ breakInOutForm.get('justification')?.value?.length || 0 }} / {{ maxJustificationLength }}
      </div>
    </div>

    <div class="bio-attachment">
      <input #fileInput type="file" (change)="onFileSelected($event)" style="display:none" />
      <button mat-stroked-button type="button" (click)="fileInput.click()">
        <mat-icon>attach_file</mat-icon>
        {{ 'DIALOGS.CHOOSE_FILE' | translate }}
      </button>
      <span *ngIf="selectedFile" class="selected-file-name">
        {{ selectedFile.name }}
        <mat-icon class="remove-file-icon" (click)="onRemoveFile()">close</mat-icon>
      </span>
    </div>
  </form>
</mat-dialog-content>

@if (saving) {
<div class="bio-saving-overlay">
  <mat-progress-spinner mode="indeterminate" diameter="60"></mat-progress-spinner>
</div>
}


